module.exports = __webpack_public_path__ + "static/media/tip_text_cat_stethoscope_fr.e6c2cc97.svg";